import React, { useCallback } from 'react';
import { Table } from 'antd';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import sortByString, { safeExtractFromObject } from '../../helpers/helpers';

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
  },
];

export default function DivisionDrawerAddBody({
  data,
  onSelectChange,
  type,
  translatedType,
}) {
  const settings = useSelector((state) => safeExtractFromObject(state, 'settings.company.settings'));

  const isUsers = type === 'Users';
  const isTeams = type === 'Teams';
  const tableOffset = isUsers ? 40 : 100;
  const scrollOffset = isUsers ? 150 : 210;

  const onHeaderRow = useCallback(() => {
    if (!settings?.uxRedesignPt1) return null;
    return {
      className: 'ontraccr-table-header',
    };
  }, [settings]);

  return (
    <>
      {
      (!isUsers && !isTeams) && <div style={{ margin: 20 }}>
        <b>Warning:</b> This will remove the {translatedType ?? type} from their
        original division
      </div>
      }
      <Table
        style={{ height: `calc(100% - ${tableOffset}px)`, }}
        columns={columns}
        dataSource={data.sort(sortByString('name'))}
        size='small'
        pagination={false}
        scroll={{
          y: `calc(100vh - ${scrollOffset}px)`
        }}
        rowSelection={{
          fixed: true,
          onChange: onSelectChange,
          getCheckboxProps: () => ({
            className: settings?.uxRedesignPt1 ? 'ontraccr-checkbox' : '',
          }),
        }}
        rowKey='id'
        onHeaderRow={onHeaderRow}
      />
    </>
  );
}

DivisionDrawerAddBody.defaultProps = {
  data: [],
  onSelectChange: () => {},
  type: '',
  translatedType: '',
};

DivisionDrawerAddBody.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  })),
  onSelectChange: PropTypes.func,
  type: PropTypes.string,
  translatedType: PropTypes.string,
};
